import { TournamentNotificationPopUp } from './components/TournamentNotificationPopUp';
import { useWindowSize } from 'react-easyrocket';
import { PwaPopup } from 'src/components/PwaPopup';
import { useNewTournamentNotification } from 'src/components/Layouts/Layout/hooks/useNewTournamentNotification';

export const TournamentAlert = () => {
  const { isMobileLayout } = useWindowSize();
  const { newTournament } = useNewTournamentNotification();
  if (!isMobileLayout) return;

  if (!newTournament) {
    return <PwaPopup />;
  }
  return <TournamentNotificationPopUp tournament={newTournament} />;
};
